import { BaseState } from '@/store/base-state';
import { TableOptions } from '@/types';
import {
  Organizations,
  OrganizationBlackListFilters,
} from '@/modules/organizations/types';

export default class BlackListState extends BaseState {
  black_list: Organizations.OrganizationBlackList[] = [];
  black_list_loading = false;
  filters: OrganizationBlackListFilters = {
    search: '',
  }

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: ['name_company'],
    sortDesc: [true],
  };
}
